module.exports = __webpack_public_path__ + "static/img/zdhf03.ffb3b73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/zdhf03.png
// module id = 120
// module chunks = 0